import React from 'react';
import HamburgerNavigationItem from './HamburgerNavigationItem';
import { useSelector } from 'react-redux';

const HamburgerNavigation = () => {
  const hamburgerNavigation = useSelector((state) => state.hamburgerNavigation);
  const contentLinks = hamburgerNavigation?.contentLinks || [];

  return <HamburgerNavigationItem links={contentLinks} />;
};

export default HamburgerNavigation;
